<template>
  <v-container class="advanced-search-container">
    <v-card light>
      <v-card-title><h2 style="font-weight: 500">{{ $tf('Advanced Search') }}</h2></v-card-title>
      <v-card-text class="py-0 px-4">
        <v-layout row wrap>
          <v-flex class="search-col" xs12 md6>
            <v-text-field
              v-model="advancedSearch.name"
              light
              clearable
              :label="$tf('Name')"
              variant="underlined"
            ></v-text-field>
          </v-flex>
          <v-flex class="search-col" xs12 md6>
            <v-checkbox
              v-model="advancedSearch.exactMatch"
              light
              :label="$tf('exactMatch')"
            />
          </v-flex>
          <v-flex class="search-col" xs12 md6>
            <v-select
              :items="fileTypes"
              light
              clearable
              v-model="advancedSearch.type"
              :label="$tf('Type')"
            />
          </v-flex>
          <v-flex class="search-col" xs12 md6>
            <v-text-field
              v-model="advancedSearch.description"
              light
              clearable
              :label="$tf('Description')"
            ></v-text-field>
          </v-flex>
          <v-flex class="search-col mt-4" xs12 md6>
            <v-select
              :items="informTypes"
              light
              clearable
              v-model="advancedSearch.isInformed"
              :label="$tf('Filter inform status')"
            />
          </v-flex>
          <v-flex class="search-col mt-4" xs12 md6>
           <v-select
              :items="starTypes"
              light
              clearable
              v-model="advancedSearch.isStarred"
              :label="$tf('Filter favourite status')"
            />
          </v-flex>
          <v-flex class="search-col mt-3" xs12 md12>
            <date-picker
              :title="$tf('Date')"
              :label="$tf('Type')"
              :selectableItems="[
                { text: $tf('CreateDate'), value: 'create' },
                { text: $tf('UpdateDate'), value: 'update' }
              ]"
              v-model="advancedSearch.date"
              @input="advancedSearch.date=$event">
            </date-picker>
          </v-flex>
          <v-flex class="search-col mt-4 label" xs12 md12>
            <span class="mr-3" style="color: black">{{ $tf('colors') }}</span>
            <span v-if="showColors || !advancedSearch.colors || advancedSearch.colors.length === 0">{{ $tf('selectColours') }}</span>
            <div v-else style="display: inline-flex">
              <div v-for="(color, index) in advancedSearch.colors"
                :key="index"
                :class="['color small', color === '' ? 'blank' : '']"
                :style="{'background-color': color}"
              />
            </div>
            <v-tooltip bottom v-if="!showColors && advancedSearch.colors && advancedSearch.colors.length > 0">
              <v-btn slot="activator" icon light small @click="showColors = true"><v-icon>arrow_drop_down</v-icon></v-btn>
              <span>{{ $tf('selectColours') }}</span>
            </v-tooltip>
            <v-btn v-else-if="!showColors" icon light small @click="showColors = true"><v-icon>arrow_drop_down</v-icon></v-btn>
            <v-btn v-else icon light small @click="showColors = false"><v-icon>arrow_drop_up</v-icon></v-btn>
          </v-flex>
          <color-picker
            v-if="showColors"
            @update-colors="(val) => { this.advancedSearch.colors = val }"
            :small="'small'"
            :values="advancedSearch.colors || []"
          />
          <v-flex v-if="vaultTypes && vaultTypes.length > 0" class="search-col" xs12 md6>
            <v-select
              :items="vaultTypes"
              item-text="name"
              item-value="stringValue"
              light
              clearable
              v-model="vaultModel"
              :label="$tf('storedAt')"
            />
          </v-flex>
          <v-flex v-if="groupsAmongSharers" class="search-col mt-3 checkbox-wrap" xs12 md12>
            <v-checkbox
              v-model="advancedSearch.searchAmongGroups"
              light
              :label="$tf('searchAmongGroups')"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="mt-4">
        <v-btn v-if="showEmptyButton" light text @click.native="$emit('clear')">
          {{ $tf('Clear filters') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn light text @click.native="$emit('close')">
          {{ $tf('Cancel') }}
        </v-btn>
        <v-btn color="primary" @click.native="search">
          {{ $tf('Search') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import DatePicker from '~/components/common/DatePicker.vue'
import ColorPicker from '~/components/common/ColorPicker.vue'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'AdvancedSearch',
  components: {
    DatePicker,
    ColorPicker
  },
  data () {
    return {
      advancedSearch: {},
      fileTypes: [
        { text: this.$tf('Directory'), value: 'directory' },
        { text: this.$tf('Study'), value: 'study' },
        { text: this.$tf('Document'), value: 'document' },
        { text: this.$tf('containerDicom'), value: 'container_dicom' },
        { text: this.$tf('dicomVault'), value: 'dicom_vault' },
        { text: this.$tf('documentVault'), value: 'document_vault' }
      ],
      informTypes: [
        { text: this.$tf('Informed'), value: true },
        { text: this.$tf('InformPassive'), value: false }
      ],
      starTypes: [
        { text: this.$tf('FavoritePassive'), value: true },
        { text: this.$tf('UnfavoritePassive'), value: false }
      ],
      showColors: false
    }
  },
  mounted () {
    this.advancedSearch = cloneDeep(this.$store.state.search.searchFields)
    if (this.$store.state.sharers.elements.length === 0) {
      this.$store.dispatch('sharers/loadElements')
    }
  },
  computed: {
    vaultModel: {
      get () {
        if (!this.advancedSearch.vault || this.advancedSearch.vault.address === null) {
          return 'null'
        }
        return JSON.stringify({
          url: this.advancedSearch.vault.address.url,
          scope: this.advancedSearch.vault.address.scope
        })
      },
      set (newValue) {
        if (newValue === 'null' || newValue === null) {
          this.advancedSearch.vault = null
        } else {
          const parsed = JSON.parse(newValue)
          this.advancedSearch.vault = this.vaultTypes.find(
            item => {
              if (item === null || item.address === null) return parsed === null
              return item.address.url === parsed.url && item.address.scope === parsed.scope
            }
          )
        }
      }
    },
    vaultTypes () {
      let accountRemotes = (this.$store.state.session.remotes || [])
      return (this.$store.state.session.reachableRemotes || [])
      .filter(vaultType => {
        if (vaultType.address === null) {
          return true
        }
        return accountRemotes.some(accRemote => accRemote.scope === vaultType.address.scope)
      })
      .map(vault => ({
        ...vault,
        stringValue: vault && vault.address ? JSON.stringify({
          url: vault.address.url,
          scope: vault.address.scope
        }) : vault ? 'null' : null
      }))
    },
    showEmptyButton () {
      return Object.keys(this.advancedSearch).filter(x => this.advancedSearch[x] != null && this.advancedSearch[x] !== '').length > 0
    },
    groupsAmongSharers () {
      return this.$store.state.sharers.elements && this.$store.state.sharers.elements.filter(e => e.group_id).length > 0
    }
  },
  methods: {
    search () {
      Object.keys(this.advancedSearch).forEach(key => {
        if (this.advancedSearch[key] === null || this.advancedSearch[key] === '') {
          delete this.advancedSearch[key]
        }
        if (key === 'colors' && this.advancedSearch[key].length === 0) {
          delete this.advancedSearch[key]
        }
      })
      if (!this.advancedSearch.searchAmongGroups || (this.advancedSearch.name && this.advancedSearch.name.trim() !== '') || this.$store.state.search.searchInput.trim() !== '') {
        this.$emit('search', this.advancedSearch)
      } else {
        this.$store.dispatch('feedback/addSnack', { text: this.$t('cannotSearchInGroupsWithoutName'), type: 'error', timeout: 10000 })
      }
    }
  }
}
</script>
<style lang="scss">
  .advanced-search-container {
    position: absolute;
    top: 30px;
    left: -15px;
    z-index: 1;
    width: 150%;
    overflow-y: auto;
    height: calc(100dvh - 50px);
    margin-top: 24px;
    padding-top: 0;
    .search-col {
      display: flex;
      align-items: end;
      padding: 5px 10px;
    }
    .label {
      font-size: 1.2rem;
      color: #0000008a;
      align-items: center;
    }
    .input-group__details {
      display: inline;
    }
    .checkbox-wrap {
        label {
          overflow: unset !important;
          text-wrap: inherit;
        }
      }
  }
  .toolbar.theme--dark .input-group--focused .icon {
    color: #1c6992 !important;
  }
  .color.small {
    width: 25px !important;
    height: 25px !important;
    padding: 5px 8px !important;
    &.blank {
      background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39%, rgba(255, 0, 0, 1) 40%, rgba(255, 0, 0, 1) 50%, rgba(255, 0, 0, 1) 60%, rgba(255, 255, 255, 1) 61%, rgba(255, 255, 255, 1) 100%);
      border: 4px solid red;
    }
  }

  @media only screen and (max-width: 960px) {
    #search-list {
      position: initial !important;
    }
    .advanced-search-container {
      width: calc(100% + 30px) !important;
      top: 40px !important;
      margin-top: 16px;
    }
  }

  @media only screen and (max-width: 600px) {
    .advanced-search-container {
      top: 32px !important;
      margin-top: 24px;
      .checkbox-wrap {
        label {
          font-size: 1em !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/AdvancedSearch.vue